export default __webpack_public_path__ + "static/media/image-090.6551c1a4.jpg";